/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Tea_Lot_TitleInputs */

const vi_trace_tea_lot_title = /** @type {(inputs: Trace_Tea_Lot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin lô chè`)
};

/**

* @param {Trace_Tea_Lot_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_tea_lot_title = /** @type {((inputs?: Trace_Tea_Lot_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Tea_Lot_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_tea_lot_title(inputs)
});